// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastPlayer-cls1_c8S","cls2":"PodcastPlayer-cls2_I9O PodcastPlayer-cls1_c8S"};